import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Modal, Space, Table, Tooltip, message } from "antd";
import axios from "axios";
import { PRIMARY_RED } from "constants/colors";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { setBreadcrumbItems } from "../../store/actions";

const Region = (props) => {
  const [region, setRegion] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState(null);

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const breadcrumbItems = [
    { title: "Region", link: "#" },
    { title: "Region Listing", link: "#" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems("Region", breadcrumbItems);
    fetchRegion();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);

  const fetchRegion = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASEURL}/region`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRegion(response.data);
    } catch (err) {
      message.error("Failed to load regions");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (regionId, regionName) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASEURL}/region/${regionId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      message.success(`Deleted region: ${regionName}`);
      fetchRegion();
    } catch (err) {
      message.error("Failed to delete region");
    }
  };

  const filteredRegions = region.filter((r) => {
    const search = searchText.toLowerCase();
    return (
      (r.regionCode || "").toLowerCase().includes(search) ||
      (r.regionName || "").toLowerCase().includes(search) ||
      (r.regionBudget || "").toString().toLowerCase().includes(search) ||
      (r.city || "").toLowerCase().includes(search) ||
      (r.state || "").toLowerCase().includes(search)
    );
  });

  const paginatedData = filteredRegions.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const columns = [
    { title: "Region Code", dataIndex: "regionCode", key: "regionCode" },
    { title: "Region Name", dataIndex: "regionName", key: "regionName" },
    { title: "Region Budget", dataIndex: "regionBudget", key: "regionBudget" },
    { title: "City", dataIndex: "city", key: "city" },
    { title: "State", dataIndex: "state", key: "state" },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => navigate(`/edit-region/${record._id}`)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="text"
              icon={<DeleteOutlined />}
              style={{ color: PRIMARY_RED }}
              onClick={() => {
                setSelectedRegion(record);
                setIsModalVisible(true);
              }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Row>
        <Col xs="12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <input
              type="text"
              placeholder="Search region..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250, padding: "6px 10px" }}
            />
            <Button
              type="primary"
              icon={<PlusOutlined />}
              style={{ backgroundColor: PRIMARY_RED }}
              onClick={() => navigate("/add-region")}
            >
              Add Region
            </Button>
          </div>

          <Card>
            <Modal
              title="Delete Region"
              visible={isModalVisible}
              onCancel={() => setIsModalVisible(false)}
              footer={[
                <Button
                  key="cancel"
                  onClick={() => setIsModalVisible(false)}
                  style={{ backgroundColor: "#6c757d", color: "white" }}
                >
                  Close
                </Button>,
                <Button
                  key="delete"
                  type="primary"
                  style={{ backgroundColor: PRIMARY_RED }}
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    handleDelete(selectedRegion._id, selectedRegion.regionName);
                    setIsModalVisible(false);
                  }}
                >
                  Delete
                </Button>,
              ]}
            >
              <p>
                Are you sure you want to delete{" "}
                <strong>{selectedRegion?.regionName}</strong> Region?
              </p>
            </Modal>

            <CardBody>
              <Table
                columns={columns}
                dataSource={paginatedData}
                rowKey="_id"
                loading={loading}
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  total: filteredRegions.length,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "50"],
                }}
                onChange={handleTableChange}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(Region);
